import React, { useCallback, useEffect, useId, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../Accordion/Accordion";
import ExtractBar from "../ExtractBar/ExtractBar";
import { observer } from "mobx-react";
import {
  commaSeperated,
  displayUnit,
  downloadPDFFile,
  exportExcel,
  getCurrentDate,
  getDisplayDate,
  getDisplayDate2,
  getExcelDateddmmyyyy,
  getExcelNumData,
  getPrintDate,
  lakhAmt,
  numWithUnit,
  //printDocument,
  // trackEventWithScreen,
} from "../../utils/functions";
import EmptyDerivatives from "../EmptyDerivaties/EmptyDerivaties";
//import PdfTable from "../PdfTable/PdfTable";
import SortTable from "../../utils/Hooks/SortTable";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import infoIcon from "../../assets/images/svg/info.svg";
import UserStore from "../../store/UserStore";
import { useMemo } from "react";
// import { DERIVATIVES, PORTFOLIO_PAGE } from "../../utils/constants";
//import { DERIVATIVES, PORTFOLIO_PAGE } from "../../utils/constants";

const accordionTableHeaderData = [
  {
    title: "",
  },
  {
    title: "Equity Exposure",
    sortable: true,
    key: "amount",
  },
  {
    title: "MTM Futures",
    sortable: true,
    key: "mtm_futures",
  },
  {
    title: "MTM Options",
    sortable: true,
    key: "mtm_options",
  },
  {
    title: "",
    sortable: false,
  },
];

const DerivativeSummary = observer(({ hasData }) => {
  const [innerWidth, setInnerWidth] = useState(0);
  const [filteredColumn, setFilteredColumn] = useState("");
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState("");
  const [currentSortKey, setCurrentSortKey] = useState("amount");
  const [currentSortingOrder, setCurrentSortingOrder] = useState(false);
  const [derivativeDetails, setDerivativeDetails] = useState(
    UserStore?.isHydrated && UserStore.derivativesDetails?.[0] !== undefined
      ? [...UserStore.derivativesDetails?.[0]]
      : [],
  );

  const derivativesData = UserStore.portfolio.clientDerivatives;
  const details = UserStore.derivativesDetails[0];
  const isHydrated = UserStore.isHydrated;

  const {
    isAscending: contentIsAscending,
    key1: contentSortKey,
    arrData: deivativeContentArray,
    setKeyForOrdering: contentSetOrder,
  } = SortTable(derivativeDetails, { key1: "name" }, true);

  useEffect(() => {
    if (UserStore.isHydrated && UserStore.derivativesDetails?.[0]) {
      setDerivativeDetails([...UserStore.derivativesDetails?.[0]]);
    }
  }, [isHydrated, details]);

  useEffect(() => {
    const updateWindowSize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWindowSize);
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, []);

  const investedValueCellRenderer = (data, key) => {
    switch (key) {
      case "name":
        return (
          <p className="invested_value_cell">
            <p>
              <TooltipComponent
                content={data.name}
                tooltipText={data.name}
                innerWidth={window.innerWidth}
              />
            </p>
          </p>
        );
      case "current_exposure":
        return (
          <p className="invested_value_cell font-roboto">
            <p>
              {numWithUnit(
                data.current_exposure?.value,
                data.current_exposure?.value_type,
              )}
            </p>
          </p>
        );
      case "expiry_date":
        return (
          <p className="invested_value_cell">
            <p>{getDisplayDate2(data.expiry_date)}</p>
          </p>
        );
      case "type":
        return (
          <p className="invested_value_cell font-roboto">
            <p>{data.type}</p>
          </p>
        );
      case "strike":
        return (
          <p className="invested_value_cell font-roboto">
            <p>{commaSeperated(data.strike)}</p>
          </p>
        );
      case "quantity":
        return (
          <p className="invested_value_cell font-roboto">
            <p>{commaSeperated(data.quantity)}</p>
          </p>
        );
      case "current_price":
        return (
          <p className="invested_value_cell font-roboto">
            <p>{commaSeperated(data.current_price?.actual_value) || "-"}</p>
          </p>
        );
      case "avg_buy_price":
        return (
          <p className="invested_value_cell font-roboto">
            <p>{commaSeperated(data.avg_buy_price?.actual_value) || "-"}</p>
          </p>
        );
      case "mtm":
        return (
          <p className="invested_value_cell font-roboto">
            {numWithUnit(data.mtm?.value, data.mtm?.value_type)}
          </p>
        );
      default:
        return (
          <p className="invested_value_cell">
            <p>{data.mtm}</p>
          </p>
        );
    }
  };
  const columns = [
    {
      label: "Instrument Name",
      key: "name",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Current Exposure",
      key: "current_exposure",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Expiry",
      key: "expiry_date",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Type",
      key: "type",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Strike Price",
      key: "strike",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Quantity",
      key: "quantity",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Buy Price",
      key: "avg_buy_price",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "CMP",
      key: "current_price",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "MTM",
      key: "mtm",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
  ];
  const exportDervativeColumn = [
    { label: "", key: "asset_class", showColumn: true },
    { label: "Exposure", key: "equity" },
    { label: "MTM (Futures)", key: "mtms" },
    { label: "MTM (Options)", key: "mtm" },
    {
      label: "Expiry",
      key: "expiry",
      cellRendererExcel: (data, row, key) => getExcelDateddmmyyyy(data, "/"),
    },
    { label: "Type", key: "type" },
    { label: "Strick", key: "strick" },
    { label: "Quantity", key: "qty" },
    { label: "Inv (Price)", key: "inv" },
    { label: "Current Price", key: "currPrice" },
    { label: "Current Exposure", key: "currExposure" },
    { label: "MTM", key: "lastMtm" },
  ];

  const exportDerivativesData = derivativesData?.map((item) => {
    return {
      asset_class: item.description,
      equity: getExcelNumData(item?.amount?.actual_value),
      mtms: getExcelNumData(item?.mtm_futures?.actual_value),
      mtm: getExcelNumData(item?.mtm_options?.actual_value),
      expiry: "",
      type: "",
      strick: "",
      qty: "",
      inv: "",
      currPrice: "",
      currExposure: "",
      lastMtm: "",
    };
  });

  let modifiedExcelData = [];
  exportDerivativesData?.reverse()?.forEach((assetClass, index) => {
    if (index === 0) {
      modifiedExcelData.push({ ...assetClass, primary: true });
      derivativeDetails?.forEach((subAssetClass) => {
        let subAssetObj = {
          asset_class: subAssetClass.name,
          equity: "",
          mtms: "",
          mtm: "",
          expiry: subAssetClass.expiry_date,
          type: subAssetClass.type,
          strick: getExcelNumData(subAssetClass.strike),
          qty: getExcelNumData(subAssetClass.quantity),
          inv: getExcelNumData(subAssetClass.avg_buy_price.actual_value),
          currPrice: getExcelNumData(subAssetClass.current_price?.actual_value),
          currExposure: getExcelNumData(
            subAssetClass.current_exposure?.actual_value,
          ),
          lastMtm: getExcelNumData(subAssetClass.mtm?.actual_value),
        };
        modifiedExcelData.push({ ...subAssetObj });
      });
    }
  });

  const handleFilter = (filterType, keyParam) => {
    setFilteredColumn(filterType);
    if (filterType === filteredColumn) {
      setFilteredColumn("");
    }
    if (keyParam === currentSortKey) {
      setCurrentSortingOrder((prevState) => !prevState);
    } else {
      setCurrentSortKey(keyParam);
      setCurrentSortingOrder(false);
    }
  };

  const handleAccordion = (accoridonName, accordionContent) => {
    setCurrentOpenAccordion(accoridonName);
    if (accoridonName === currentOpenAccordion) {
      setCurrentOpenAccordion("");
    }
  };

  const handleSortContent = (key) => {
    if (
      key === "current_exposure" ||
      key === "current_price" ||
      key === "avg_buy_price" ||
      key === "mtm"
    ) {
      contentSetOrder({ key1: key, key2: "actual_value" });
    } else {
      contentSetOrder({ key1: key });
    }
  };

  const rowRenderer = (eachRowData) => (
    <tr
      style={{
        overflow: "visible",
      }}
    >
      {columns.map((column, index) => {
        if (column?.cellRenderer) {
          return (
            <td key={index}>{column?.cellRenderer(eachRowData, column.key)}</td>
          );
        } else {
          return <td key={index}>{eachRowData[column.key]}</td>;
        }
      })}
    </tr>
  );

  const headerRenderer = ({ label, key, sortable, classn }) => (
    <td className={classn && classn}>
      <div className="header_cell cursor blueTextColor">
        <button
          className="accordion-content-header-button"
          onClick={() => handleSortContent(key)}
        >
          <p>{label}</p>
          {sortable && (
            <div className="accordion_table_header_child_icon">
              <img
                src={
                  contentIsAscending && contentSortKey === key
                    ? sortedIcon
                    : !contentIsAscending && contentSortKey === key
                      ? sortedAtoz
                      : contentSortKey !== key
                        ? unsortedIcon
                        : ""
                }
                alt="sort"
              />
            </div>
          )}
        </button>
      </div>
    </td>
  );

  const TooltipComponent = ({ content, tooltipText }) => {
    const id = useId();

    const getWidth = useCallback(() => {
      const screenWidth = window.innerWidth;
      return (screenWidth * (screenWidth > 1200 ? 0.28 : 0.2)) / 1.21 - 14;
    }, [innerWidth]);

    const [isTooltipPresent, setIsTooltip] = useState(false);
    useEffect(() => {
      if (document.getElementById(id)) {
        const screenWidth = document.getElementById(id)?.scrollWidth;

        setIsTooltip(getWidth() - 15 < screenWidth);
      }
    }, [document.getElementById(id)]);

    const getContent = useMemo(() => {
      return (
        <div className="tooltip-container1">
          <div
            id={id}
            className="content1"
            style={{
              maxWidth: `${getWidth()}px`,
              // maxWidth: "341px",
            }}
          >
            {content}
          </div>
          {isTooltipPresent ? (
            <div
              // title1={content}
              className="tooltip_image"
            >
              <img src={infoIcon} />
              <div className="tooltip-cont">{content}</div>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }, [innerWidth, isTooltipPresent]);

    return <> {getContent}</>;
  };

  if (derivativesData?.length) {
    return (
      <div className="liabilities_summary_outside">
        <ExtractBar
          extractExcel={() => {
            exportExcel({
              sheetname: "Derivatives Summary",
              columns: exportDervativeColumn,
              data: modifiedExcelData,
              reportDetails: {
                relatioshipManager: UserStore?.exportDetails?.find(
                  (item) => item.role === "RM",
                )?.name,
                serviceManager: UserStore?.exportDetails?.find(
                  (item) => item.role === "CXO",
                )?.name,
                date: getPrintDate(UserStore.asOfDate),
                clientName:
                  UserStore.getData === "fam"
                    ? UserStore.userData?.family_name
                    : UserStore.userData?.full_name,
              },
              excelName: `Derivatives Details - ${getCurrentDate()}`,
            });
          }}
          extractPdf={() => {
            // printDocument("derivatives", {
            //   name: "Derivatives Details",
            // });

            return downloadPDFFile({
              headerName: "Derivatives Summary",
              fileId: "derivatives",
              name: "Derivatives Details",
              columns: exportDervativeColumn,
              data: modifiedExcelData,
            });
          }}
          title={"Derivatives Summary"}
        />
        <div className="liabilities_summary_data">
          <div style={{}} className="liab_outstanding_value">
            <h2 style={{ flexDirection: "column" }}>
              <span
                className="heading"
                style={{ width: "100%", textTransform: "capitalize" }}
              >
                {"Total Exposure "}
              </span>{" "}
              <div className="derivatives_values">
                <div className="amtUnit">
                  {derivativesData?.[0]?.amount?.value
                    ? `${derivativesData?.[0]?.amount?.value + " "}`
                    : "-"}
                  <h4
                    className="unitFont"
                    style={{ fontWeight: 500, display: "inline-block" }}
                  >
                    {" " + derivativesData?.[0]?.amount?.value_type}
                  </h4>
                </div>{" "}
                <span>{` As on ${
                  getDisplayDate(derivativesData?.[0]?.as_of_date) || ""
                }`}</span>{" "}
              </div>
            </h2>
            <h2
              style={{
                marginLeft: "120px",
                flexDirection: "column",
              }}
            >
              <span className="heading" style={{ textTransform: "capitalize" }}>
                {"Total MTM "}
              </span>{" "}
              <div className="derivatives_values">
                <div className="amtUnit">
                  {lakhAmt(
                    Number(derivativesData?.[0].mtm_futures.actual_value) +
                      Number(derivativesData?.[0].mtm_options.actual_value),
                  ) + " "}
                  <h4
                    className="unitFont"
                    style={{ fontWeight: 500, display: "inline-block" }}
                  >
                    {" " +
                      displayUnit(derivativesData?.[0].mtm_options.value_type)}
                  </h4>
                </div>{" "}
                <span>{` As on ${
                  getDisplayDate(derivativesData?.[1]?.as_of_date) || ""
                }`}</span>{" "}
              </div>
            </h2>
          </div>
          <div className="lackvalue"> </div>
          <table className="accordion_table derivative_data">
            <thead className="accordion_table_header">
              {accordionTableHeaderData?.map((header, index) => (
                <th
                  key={index}
                  aria-sort={
                    currentSortKey === header.key
                      ? currentSortingOrder
                        ? "Ascending"
                        : "Descending"
                      : undefined
                  }
                  className="accordion_table_header_child"
                  style={{ width: header.width }}
                >
                  {header.sortable ? (
                    <button
                      className="header-button"
                      onClick={() => handleFilter(header.title, header.key)}
                    >
                      <p className="accordion_table_header_child_heading blueTextColor">
                        {header.title}
                      </p>

                      <div className="accordion_table_header_child_icon">
                        <img
                          src={
                            currentSortingOrder && currentSortKey === header.key
                              ? sortedIcon
                              : !currentSortingOrder &&
                                  currentSortKey === header.key
                                ? sortedAtoz
                                : currentSortKey !== header.key
                                  ? unsortedIcon
                                  : ""
                          }
                          alt="sort"
                        />
                      </div>
                    </button>
                  ) : (
                    <p className="accordion_table_header_child_heading blueTextColor">
                      {header.title}
                    </p>
                  )}
                </th>
              ))}
            </thead>

            <tbody className="accordion_table_data">
              {derivativesData?.map((rowData, index) =>
                rowData.description !== "Total Exposure" ? (
                  <>
                    <Accordion>
                      <AccordionHeader>
                        <>
                          <td
                            key={index}
                            className="accordion_table_data_row_td"
                          >
                            <div className="asset_class_wrapper">
                              <p className="asset_class_text">
                                {rowData.description}
                              </p>
                            </div>
                          </td>
                          <td className="accordion_table_data_row_td">
                            <div className="asset_class_wrapper">
                              <p className="asset_class_text font-roboto">
                                {numWithUnit(
                                  rowData.amount.value,
                                  rowData.amount.value_type,
                                )}{" "}
                              </p>
                            </div>
                          </td>{" "}
                          <td className="accordion_table_data_row_td">
                            <div className="asset_class_wrapper">
                              <p className="asset_class_text font-roboto">
                                {numWithUnit(
                                  rowData.mtm_futures.value,
                                  rowData.mtm_futures.value_type,
                                )}{" "}
                              </p>
                            </div>
                          </td>{" "}
                          <td className="accordion_table_data_row_td">
                            <div className="asset_class_wrapper">
                              <p className="asset_class_text  font-roboto">
                                {numWithUnit(
                                  rowData.mtm_options.value,
                                  rowData.mtm_options.value_type,
                                )}{" "}
                              </p>
                            </div>
                          </td>
                          <td className="accordion_table_data_row_td">
                            <div
                              className="accordion_down_btn derivatives_summary_btn_animation buttonBlueBorder"
                              onClick={() => {
                                handleAccordion(
                                  rowData.description,
                                  rowData.accordionContent,
                                );
                                handleSortContent("name");
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {currentOpenAccordion === rowData.description ? (
                                <svg
                                  width="13"
                                  height="8"
                                  viewBox="0 0 13 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.05629 2.77309L6.70312 2.42069L6.34996 2.77309L2.11351 7.00031L1.41023 6.29703L6.70312 1.00414L11.996 6.29703L11.2927 7.00031L7.05629 2.77309Z"
                                    stroke="#404040"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="13"
                                  height="8"
                                  viewBox="0 0 13 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
                                    stroke="#404040"
                                  />
                                </svg>
                              )}
                            </div>
                          </td>
                        </>
                      </AccordionHeader>
                      <AccordionContent
                        open={currentOpenAccordion === rowData.description}
                        activeClassName="derivatives"
                      >
                        <table className="table accordion_content_custom_table">
                          <thead>
                            <tr>{columns?.map(headerRenderer)}</tr>
                          </thead>
                          <tbody>
                            {deivativeContentArray?.map(rowRenderer)}
                          </tbody>
                        </table>
                      </AccordionContent>
                    </Accordion>
                  </>
                ) : null,
              )}
            </tbody>
          </table>
        </div>
        {/* <PdfTable
          headerName={"Derivatives Summary"}
          data={modifiedExcelData}
          columns={exportDervativeColumn}
          id="derivatives"
        /> */}
      </div>
    );
  } else {
    return (
      <div className="no_data_liabilites">
        <EmptyDerivatives
          message={
            "You do not have any Derivatives investments held with Nuvama"
          }
        />
      </div>
    );
  }
});

export default DerivativeSummary;
